<template>
  <div>
    <div v-if="slotData">
      <v-row :no-gutters="noGutters">
        <v-col cols="10" sm="4"> {{ label }} </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col v-if="slotCol" cols="12" sm="7">
          <slot name="value" />
        </v-col>
        <v-col
          v-else
          cols="12"
          style="border-style: dotted; border-width: thin"
        >
          <slot name="value" />
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row :no-gutters="noGutters">
        <v-col cols="10" sm="4"> {{ label }} </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7" v-if="oldValueData">
          {{ oldData }} <span class="red--text">( before )</span>
        </v-col>
        <v-col cols="12" sm="7" v-else>
          {{ data == null ? '' : valueData }}
        </v-col>
      </v-row>
      <v-row v-if="oldValueData" :no-gutters="noGutters">
        <v-col cols="10" sm="4" />
        <v-col cols="2" sm="1" />
        <v-col cols="12" sm="7">
          {{ data == null ? '' : valueData }}
          <span class="red--text">( after )</span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    oldValueData: {
      type: Boolean,
      default: false,
    },
    valueData: {
      type: [String, Number],
      default: null,
    },
    oldData: {
      type: [String, Number, Boolean],
      default: null,
    },
    data: {
      type: null,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    noGutters: {
      type: null,
      default: null,
    },
    slotData: {
      type: null,
      default: null,
    },
    slotCol: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>
